export default {
  name: 'LayoutRow',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    // 间距
    gutter: Number,
    // flex 规则
    justify: {
      type: String,
      default: 'start'
    },
  },
  computed: {
    style() {
      const ret = {};

      if (this.gutter) {
        ret.marginLeft = `-${this.gutter / 2}px`;
        ret.marginRight = ret.marginLeft;
      }

      return ret;
    }
  },
  render(h){
    return h(this.tag, {
      class: [
        'is-list',
        'mc-row'
      ],
      style: this.style,
    }, this.$slots.default);
  }

}




// WEBPACK FOOTER //
// ./src/components/layout-row.js